import React, { useEffect } from "react";

import styled from "styled-components";
import { Container } from "react-bootstrap";
import { ArticleWrapper } from "./styledPoliciesPage";

import { PoliciesList } from "../../../utility/content/Policies";

import scrollToTop from "../../../libs/scrollToTop";

import { StyledSection, StyledMark } from "../../../style/base/styledPublicPages";

export default function PoliciesPageComponent() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <StyledSection>
      <Container className="mb-5">
        <h1 className="text-center mb-3">
          <StyledMark>قوانین و مقرارت</StyledMark>
        </h1>
        {PoliciesList.map((item) => {
          return (
            <ArticleWrapper className="mb-5" key={item.id}>
              <StyledH4 className="text-primary mb-4 ">{item.title}</StyledH4>
              <p className="text-muted">{item.description}</p>
            </ArticleWrapper>
          );
        })}
      </Container>
    </StyledSection>
  );
}

const StyledH4 = styled.h4`
  font-size: var(--font-size-lg);
`;
